import React, { useState, useEffect } from "react";
import localforage from "localforage";
import Dashboard from "./Dashboard";

// Users allowed to view the TDP Escalations dashboard.
const ESCALATIONS_ALLOWED = [
  "chaitanya@showtimeconsulting.in",
  "himani.sehgal@showtimeconsulting.in",
  "sachivendra.yaska@showtimeconsulting.in",
  "challa.sravya@showtimeconsulting.in",
  "sabavat.eshwar@showtimeconsulting.in",
  "bhawna.shraddha@showtimeconsulting.in",
  "sanya.oraon@showtimeconsulting.in",
  "kritarth.sharma@showtimeconsulting.in",
  "alimpan@showtimeconsulting.in",
  "rs@showtimeconsulting.in",
  "khurshid.hussain@showtimeconsulting.in",
  "khushboo@showtimeconsulting.in",
  "aditya.pandit@showtimeconsulting.in",
    "pardhasaradhi@showtimeconsulting.in",
];

// Embeds the self-contained escalations dashboard (served as a static file at
// /escalations/index.html) inside the portal layout — but only for the
// allow-listed users. Gating here (not just hiding the tile) blocks direct
// URL access too.
const EscalationsDashboard = () => {
  const [email, setEmail] = useState(null); // null = still loading

  useEffect(() => {
    localforage
      .getItem("email")
      .then((e) => setEmail((e || "").trim().toLowerCase()))
      .catch(() => setEmail(""));
  }, []);

  if (email === null) {
    return (
      <div style={{ flex: 1 }}>
        <Dashboard />
        <div style={{ padding: 40, textAlign: "center", color: "#5b6b80" }}>
          Loading…
        </div>
      </div>
    );
  }

  const allowed = ESCALATIONS_ALLOWED.includes(email);

  if (!allowed) {
    return (
      <div style={{ flex: 1 }}>
        <Dashboard />
        <div
          style={{
            maxWidth: 520,
            margin: "60px auto",
            padding: "32px 28px",
            textAlign: "center",
            background: "#fff",
            border: "1px solid #f1c8cf",
            borderRadius: 16,
            boxShadow: "0 16px 40px rgba(19,49,91,.12)",
          }}
        >
          <h2 style={{ color: "#b00020", marginTop: 0 }}>Access restricted</h2>
          <p style={{ color: "#3a4a5e", lineHeight: 1.5 }}>
            You don't have permission to view the TDP Escalations dashboard.
            Please contact the admin if you believe this is a mistake.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <Dashboard />
      <div style={{ flex: 1, padding: "0 12px 12px", minHeight: "80vh" }}>
        <iframe
          title="TDP Escalations · Live Dashboard"
          src="/escalations/index.html"
          style={{
            width: "100%",
            height: "calc(100vh - 120px)",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            background: "#ffffff",
          }}
        />
      </div>
    </div>
  );
};

export default EscalationsDashboard;
